var my_lat = 0.;
var my_lng = 0.;
var my_zoom = 7;
var gfonte;
var gfonte_max;
if (lit_cook("lat") == "") my_lat = 45.28648197278281;
else my_lat = parseInt(lit_cook("lat"));
if (lit_cook("lng") == "") my_lng = -73.24310302734375;
else my_lng = lit_cook("lng") * 1.;
if (lit_cook("zoom") == "") my_zoom = 7;
else my_zoom = parseInt(lit_cook("zoom"));
if (lit_cook("topo") == "") my_topo = 0;
else my_topo = parseInt(lit_cook("topo"));
var map;
var markersArray;
// Listen for orientation changes
window.addEventListener("orientationchange", function() {
    // Announce the new orientation number
    //alert(window.orientation);
    initialize();
}, false);
function initialize() {
    //if(window.innerHeight < window.innerWidth){alert("Utilisez en mode portrait")}
    gxsize = Math.min(1000, window.innerWidth);
    if (gxsize == window.innerWidth) gxsize = gxsize * .98;
    gysize = Math.min(800, window.innerHeight * 6. / 10.);
    gfonte_max = 3;
    gfonte = 0;
    if (gxsize < 1000) gfonte = 2;
    if (gxsize < 800) gfonte = 1;
}

//# sourceMappingURL=imeteo.888e8372.js.map
